import Controller from "./dispInfo.controller";
import template from "./dispInfo.html";

const dispInfo = {
  template,
  controller: Controller,
  bindings: {
    icon: "@",
    dispTitle: "<", // I chose a binding in case it's sent from iteration on from the controller so it supports both binding and string
    info: "<",
  },
};

export default dispInfo;



// WEBPACK FOOTER //
// ./src/components/dispInfo/dispInfo.component.js